// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","711":"friend"}[chunkId] || chunkId) + "." + {"18":"5f592ad2","594":"331da30e","711":"25e16e00"}[chunkId] + ".css";
};